import { BrowserModule } from '@angular/platform-browser';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

//import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { Typeahead } from 'ng2-typeahead';

import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { HomeModule } from './home/home.module';
import { StaffModule } from './staff/staff.module';
import { AddLeadModule } from './lead/lead.module';
import { ReportModule } from './Reports/reports.module';
import { GeographyModule } from './system_setting/geography_master/geography_master.module';
import { ConfigFieldModule  } from './system_setting/DFB/config_field/config_field.module';
import { ConfigureTabModule  } from './system_setting/DFB/configure_tab/tab.module';
import { ConfigureProductModule } from './system_setting/configure_product/config_product.module';
import { ConfigureGroupModule } from './system_setting/DFB/configur_group/group.module';
import { ConfigureSectionModule  } from './system_setting/DFB/configure_section/section.module';
import { ContextScreenModule  } from './system_setting/DFB/context_screen/context.module';
import { TemplateModule } from './system_setting/DFB/template/template.module';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { MomentModule } from 'angular2-moment'; // optional, provides moment-style pipes for date formatting

import {
  FooterComponent,
  HeaderComponent,
  ConfigService,
  ApiService,
  JwtService,
  SharedModule,
  UserService,
  AuthGuard,
  DropdownDirective,
  CommonService,
} from './shared';

import { Http, XHRBackend, RequestOptions } from '@angular/http';
import { httpFactory } from './http.factory';



const rootRouting: ModuleWithProviders = RouterModule.forRoot([], { useHash: true });

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
  ],
  imports: [
    BrowserModule,
    HomeModule,
    AddLeadModule,
    ReportModule,
    StaffModule,
    SharedModule,
    AuthModule,
    rootRouting,
    GeographyModule,
    ConfigFieldModule,
    ConfigureTabModule,
    ConfigureProductModule,
    ConfigureGroupModule,
    ConfigureSectionModule,
    TemplateModule,
    ContextScreenModule,
    BrowserAnimationsModule,
   // NgbModule.forRoot(),
    ToastModule.forRoot(),
     NgIdleKeepaliveModule.forRoot()
  ],
  providers: [
    ConfigService,
    ApiService,
    AuthGuard,
    JwtService,
    UserService,
    CommonService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts